import PropTypes from "prop-types";

export const ReceiptModel = {
  id: null,
  receiptNumber: "",
  receiptDate: "",
  amountPaid: 0.0,
  reservationId: "",
  userId: "",
  invoiceId: "",
  payments: [{ method: "", amount: 0.0, cardLastFour: "", otherDetails: "" }],
  paidBy: "",
  paymentDate: "",
  prevBalance: 0.0,
  balanceDue: "",
  cashierName: "",
  comment: "",
};

export const ReceiptModelShape = PropTypes.shape({
  id: PropTypes.number,
  receiptNumber: PropTypes.string,
  receiptDate: PropTypes.string,
  amountPaid: PropTypes.number,
  reservationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  userId: PropTypes.string,
  invoiceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  payments: PropTypes.arrayOf(
    PropTypes.shape({
      method: PropTypes.string,
      amount: PropTypes.number,
      cardLastFour: PropTypes.string,
      otherDetails: PropTypes.string,
    })
  ),
  paidBy: PropTypes.string,
  paymentDate: PropTypes.string,
  prevBalance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  balanceDue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  cashierName: PropTypes.string,
  comment: PropTypes.string,
});
